import { render, staticRenderFns } from "./UploadBankPage.vue?vue&type=template&id=229851f8&scoped=true"
import script from "./UploadBankPage.vue?vue&type=script&lang=js"
export * from "./UploadBankPage.vue?vue&type=script&lang=js"
import style0 from "./UploadBankPage.vue?vue&type=style&index=0&id=229851f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229851f8",
  null
  
)

export default component.exports